<script lang="ts">
  import ProjectGridCard from '../../components/project-card/ProjectGridCard.svelte'
  import i18n from '../../i18n'
  import { navbarSearchQuery } from '../../stores/navbar-search'
  import { useProjects } from '../../hooks/projects'
  import EmptyState from '../../components/empty-state/EmptyState.svelte'
  import { Grid2x2X, Plus } from '@lucide/svelte'
  import { createMutation } from '@tanstack/svelte-query'
  import { createProject } from '../../api/projects'
  import { goto } from '@mateothegreat/svelte5-router'
  import Pagination from '../../components/pagination/Pagination.svelte'
  import SortButton from '../../components/sort-button/SortButton.svelte'
  import queryClient from '../../constants/query-client'

  let page = $state(1)
  let sortBy = $state('updated_at desc')
  let query = $derived(
    useProjects({
      page,
      'q[s]': sortBy,
      'q[name_cont]': $navbarSearchQuery,
    }),
  )

  const mutation = createMutation(
    () => ({
      mutationFn: () => {
        return createProject('Untitled')
      },
      onSuccess: (data) => {
        goto(`/projects/${data.data.id}`)
      },
    }),
    () => queryClient,
  )
</script>

<div class="projects">
  <div class="head">
    <div class="sorting">
      <p>{$i18n.t('projects.sortBy')}</p>
      <SortButton
        active={sortBy === 'updated_at desc'}
        onclick={() => {
          sortBy = 'updated_at desc'
        }}
      >
        {$i18n.t('projects.filters.lastModified')}
      </SortButton>
      <SortButton
        active={sortBy === 'name asc'}
        onclick={() => {
          sortBy = 'name asc'
        }}
      >
        {$i18n.t('projects.filters.name')}
      </SortButton>
      <SortButton
        active={sortBy === 'created_at desc'}
        onclick={() => {
          sortBy = 'created_at desc'
        }}
      >
        {$i18n.t('projects.filters.dateCreated')}
      </SortButton>
    </div>
  </div>
  {#if query.isLoading}
    <p>{$i18n.t('loading')}</p>
  {:else if query.isError}
    <p>{$i18n.t('projects.error')}</p>
  {:else if query.isSuccess}
    {#if query.data.data.length > 0}
      <div class="grid">
        {#each query.data.data as project (project.id)}
          <ProjectGridCard {project} />
        {/each}
      </div>
      <Pagination
        totalPages={Number.parseInt(
          query.data?.headers['total-pages'] ?? '',
          10,
        )}
        bind:currentPage={page}
      />
    {:else}
      <EmptyState
        buttonIcon={Plus}
        buttonLabel={$i18n.t('projects.emptyState.buttonLabel')}
        icon={Grid2x2X}
        onButtonClick={mutation.mutate}
        subtitle={$i18n.t('projects.emptyState.subtitle')}
        title={$i18n.t('projects.emptyState.title')}
      />
    {/if}
  {/if}
</div>

<style lang="scss">
  .projects {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(18rem, 1fr));
      gap: 1rem;
    }

    .head {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;

      .sorting {
        display: flex;
        align-items: center;
        gap: 0.5rem;

        p {
          font-size: 0.75rem;
          color: var(--muted-foreground);
        }
      }
    }
  }
</style>
